import axios from 'axios';
import {useMutation} from '@tanstack/react-query';

import {Keys} from 'client/api/_keys';
import {Routes} from 'client/api/_routes';

import {cartAtom} from 'store';
import {useSetRecoilState} from 'recoil';
import {onRemoveCartItemRes} from './helper';

const removeCartItem = async (id: string) =>
  axios.put(Routes.REMOVE_CART_ITEM + '/' + id);

export const useRemoveCartItem = (id: string) => {
  const setCart = useSetRecoilState(cartAtom);

  return useMutation({
    mutationKey: [id, Keys.REMOVE_CART_ITEM_MUT],
    mutationFn: () => removeCartItem(id),
    onSuccess: res => onRemoveCartItemRes({cart: res.data.cart, setCart}),
  });
};
